const dateTypes = [
  'created_dt',
  'dataRefreshedTime',
  'date',
  'endDate',
  'startDate',
  'timeEntryDate',
  'updated_dt',
]

const numericalTypes = [
  'adEcpm',
  'adImpressions',
  'adRequests',
  'allImpressions',
  'allRevenue',
  'booked',
  'clicks',
  'ctr',
  'delivered',
  'discrepancyPercentage',
  'estimatedRevenue',
  'grossRevenue',
  'impressions',
  'impressionsYesterday',
  'localClicks',
  'localImps',
  'matchedRequests',
  'netRevenue',
  'osi',
  'potentialLostRevenue',
  'potentialLostRevenuePercentage',
  'rate',
  'revenue',
  'thirdPartyClicks',
  'thirdPartyImps',
  'totalImpressions',
  'unfilledImpressions',
  'yieldEstimatedRevenue',
  'yieldEstimatedCPM',
  'yieldImpressions',
]

const percentageTypes = [
  'adImpressionPerc',
  'coverage',
  'ctr',
  'fillRate',
  'potentialLostRevenuePercentage',
  'unfilledPercentage',
]

const columnTypes = {
  date: dateTypes,
  numerical: numericalTypes,
  percentage: percentageTypes,
}

const columns = {
  types: columnTypes,

  isTypeDate(columnName) {
    return dateTypes.indexOf(columnName) !== -1
  },
  isTypeNumerical(columnName) {
    return numericalTypes.indexOf(columnName) !== -1
  },
  isTypePercentage(columnName) {
    return percentageTypes.indexOf(columnName) !== -1
  },
}

export default columns
